import { useContext } from 'react';
import {FilterContext} from "../contexts/FilterContext";

const useFilter = () => useContext(FilterContext);

export default useFilter;
